/**
 * Helper - checks if a given itemCreator should be included
 * @param {object} itemCreator
 * @param {string} itemCreator.attribution
 * @param {array}  itemCreator.rolesReferenceSet
 * @param {array}  [allowedRoles]
 * @param {array}  [allowedAttributions]
 * @returns {boolean}
 */
export function isValidCreator(itemCreator, allowedAttributions, allowedRoles) {
    const { attribution, rolesReferenceSet } = itemCreator || {};

    let isValid = !!itemCreator;
    // if allowed attributions passed, check that creator has valid attribution
    if (isValid && allowedAttributions) {
        isValid = allowedAttributions.includes(attribution);
    }
    // if allowed roles passed, check that creator has valid role
    if (isValid && allowedRoles) {
        isValid = !!rolesReferenceSet.find(role => allowedRoles.includes(role.enumName));
    }
    return isValid;
}

/**
 * Helper - builds creator info string (for artists)
 *  (country) OR (birth country) OR (birth - death, country)
 * @param {object} creator
 * @param {string} [creator.dateOfBirth]
 * @param {string} [creator.dateOfDeath]
 * @param {string} [creator.countryOfOrigin]
 * @returns {string}
 */
export function buildCreatorInfoString(creator) {
    if (!creator || (!creator.dateOfBirth && !creator.countryOfOrigin)) {
        return '';
    }

    let infoStr = '';
    const birth = creator.dateOfBirth;
    const death = creator.dateOfDeath;
    const country = creator.countryOfOrigin;
    const date = creator.date;

    if (date) {
        infoStr += date;
    } else if (birth) {
        // 'birth' OR 'birth - death'
        infoStr += birth + (death ? ` - ${death}` : '');
    }
    if (country) {
        // 'birth - death, country' OR 'birth country' OR 'country'
        infoStr += (birth || date ? ', ' : ' ') + country;
    }
    return `(${infoStr.trim()})`;
}

export function buildCreatorRolesString(roles) {
    if (roles && roles.length) {
        return `(${roles.map(role => role.displayName).join(', ')})`;
    }
    return '';
}
